import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { startLoading, doneLoading } from '../utils/loading'
import {
  authen,
  setSession,
  logout,
  clearSession,
  clearLocalStorage,
  setLocalStorage,
  clearSessionStorage,
} from '../redux/actions/auth'
import { FlexboxGrid } from 'rsuite'
import ErrorWidget from '../widgets/errorWidget/ErrorWidget'
import Logo from '../components/Logo'
import AlertWidget from '../widgets/confirm/AlertWidget'
import { userClassification } from '../utils/userClassificationUtil'
import pathname from '../constants/pathname'
import { isEmpty } from 'lodash-es'

export default function Logon() {
  const [error, setError] = useState()
  const [notSupport, setNotSupport] = useState()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const bars = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]

  const handleLogon = async () => {
    startLoading()
    try {
      // console.log('params', params)
      const params_code = params.get('code')
      const params_state = params.get('state')
      const response = await authen(params_code, params_state)

      if (response.success && response?.model?.tokenInfo?.access_token) {
        await clearLocalStorage()
        await clearSessionStorage()

        await setSession(response.model)

        await setLocalStorage(response?.model?.userInfo, params_code, params_state)

        if (response?.model?.pdpaInfo) {
          let isAccepted = response.model.pdpaInfo.isAccepted

          if (isAccepted) {
            localStorage.setItem('termsUrl', response.model.pdpaInfo.termsUrl)
          } else {
            window.location.href = response.model.pdpaInfo.redirectUrl
          }
        }

        let redirectUrl = pathname.dashboardRoot //`/dashboard`

        let code = response?.model?.userInfo?.activeRole
        if (code == 'THP-Auditor' || code == 'THP-ExternalAuditor') {
          redirectUrl = pathname.audit.AuditReportSummary
        } else {
          let redirectLink = sessionStorage.getItem('redirect-link')
          if (!isEmpty(redirectLink)) {
            redirectUrl = redirectLink
          }
          sessionStorage.removeItem('redirect-link')
        }

        if (redirectUrl) {
          window.location.href = redirectUrl
          window.opener = null
        } else {
          setNotSupport(true)
        }
      } else {
        setError({})
      }
      doneLoading()
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors.message,
        })
      } else {
        setError({})
      }
      doneLoading()
    }
  }

  const handleLogout = async () => {
    try {
      const result = await logout()
      clearSession(result)
    } catch (e) {
      clearSession()
    }
  }

  useEffect(() => {
    handleLogon()
  }, [])

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  return (
    <FlexboxGrid justify="center" align="middle">
      {/* <div className="logo-react-suite" style={{ alignContent: 'center' }}>
        <Logo width={380} height={300} />
      </div> */}

      <div class="loading-overlay">
        <Logo width={300} height={300} />
        <div class="helix-loader" style={{ marginTop: -40 }}>
          {bars.map((e) => (
            <div class="bar"></div>
          ))}
        </div>
      </div>

      {/* <AlertWidget
        title={'แจ้งเตือน'}
        show={notSupport}
        detail={`ไม่พบสิทธิในการใช้งานระบบ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
        onClose={() => {
          setNotSupport(false)
          handleLogout()
        }}
      /> */}
    </FlexboxGrid>
  )
}
